import React, { Component, Fragment } from 'react';
import { withRouter } from '../WithRouterHOC';
import Scrollbar from 'react-scrollbars-custom';
import { Modal, message, Form, Input, Select, Button, Upload } from 'antd';
import {
  QuestionCircleFilled,
  LoadingOutlined,
  PlusOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import './applyClassly.scss';
import HTTP from '../../script/service';
import Util from '../../script/util';

import PricesRemark from '../pricesRemark/PricesRemark';

const timsSelects = [
  '00:00',
  '01:00',
  '02:00',
  '03:00',
  '04:00',
  '05:00',
  '06:00',
  '07:00',
  '08:00',
  '09:00',
  '10:00',
  '11:00',
  '12:00',
  '13:00',
  '14:00',
  '15:00',
  '16:00',
  '17:00',
  '18:00',
  '19:00',
  '20:00',
  '21:00',
  '22:00',
  '23:00',
  '24:00',
];
class ApplyClassly extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      skillType: 1,
      gameDatas: [],
      skillItem: null,
      formValues: {},
      showSkillLy: true,
    };
  }
  componentDidMount() {
    if (this.props.mode == 'content') {
      this.getSkillType(this.props.skillType, true);
    }
  }
  showModal = (skillType = 1, showSkillLy) => {
    this.getSkillType(skillType, showSkillLy);
  };
  hideModal = () => {
    this.setState({ visible: false }, () => {
      this.props.nextEvent && this.props.nextEvent(this.state.skillType);
    });
  };
  getSkillType = (skillType, showSkillLy = false) => {
    HTTP._get_findBySkillType({
      uid: this.props.base.uid,
      skillType,
      filterType: showSkillLy ? 1 : 0,
    }).then((res) => {
      if (res.code == 200) {
        this.setState(
          {
            showSkillLy,
            skillType,
            visible: true,
            gameDatas: res.data,
          },
          () => {
            let selItem = res.data[0]?.skillItems[0];
            if (this.props.categoryId) {
              let allSkillitems = [];
              res.data.forEach((item) => {
                allSkillitems = allSkillitems.concat(item.skillItems);
              });
              let sele = allSkillitems.filter(
                (item) => item.skillItemId == this.props.categoryId
              );
              if (sele && sele.length) {
                selItem = sele[0];
              }
            }
            this.setSkillItems(selItem);
          }
        );
      } else {
        message.warning(res.message);
      }
    });
  };
  setSkillItems = async (item) => {
    const skillItem = { ...item };
    skillItem.level = item.level?.split(',');
    skillItem.prices = item.prices?.split(',');
    if (item.goodLocation) {
      skillItem.goodLocation = item.goodLocation.split(',');
    }
    if (item.orderArea) {
      skillItem.orderArea = item.orderArea.split(',');
    }
    skillItem.pricesAd = JSON.parse(item.pricesAd || '[]');
    const data = await HTTP._find_GodCategoryInfoByUid({
      uid: this.props.base.uid,
      categoryId: skillItem.skillItemId,
    });
    if (
      data.data &&
      data.data?.serviceTime &&
      data.data?.serviceTime.toString().indexOf('~') != -1
    ) {
      let serviceTime = data.data.serviceTime.split('~');
      data.data.timeStart = serviceTime[0];
      data.data.timeEnd = serviceTime[1];
      data.data.serviceTime = null;
    } else if (data.data) {
      data.data.serviceTime = null;
    }
    this.setState({ skillItem, formValues: data.data || {} });
  };
  handleSubmit = () => {
    const { formValues, skillType, skillItem } = this.state;
    if (!formValues.level && formValues.showCategoryLevel) {
      message.warning('请选择技能等级');
      return;
    }
    if (!formValues.skillPic) {
      message.warning('请上传认证图片');
      return;
    }
    if (!formValues.price) {
      message.warning('请选择服务单价');
      return;
    }
    if (!formValues.timeStart || !formValues.timeEnd) {
      message.warning('请选择接单时间');
      return;
    } else {
      formValues.serviceTime = formValues.timeStart + '~' + formValues.timeEnd;
    }
    if (skillType == 1 && !formValues.orderArea) {
      message.warning('请选择接单大区');
      return;
    }
    if (skillType == 1 && !formValues.goodLocation) {
      message.warning('请选择擅长位置');
      return;
    }
    if (!formValues.orderRemark) {
      message.warning('请填写文字介绍');
      return;
    }
    if (!formValues.voiceUrl) {
      message.warning('请上传语音介绍');
      return;
    }
    const slen = formValues.voiceLength || Math.floor(formValues.soundLen);
    if (!(slen >= 5 && slen <= 15)) {
      message.error('声音长度需大于5秒小于15秒');
      return;
    }
    this.setState({ loading: true });
    HTTP._v6_addAptitude({
      ifAuth: 0,
      uid: this.props.base.uid,
      categoryId: skillItem.skillItemId,
      level: formValues.level,
      skillPic: formValues.skillPic,
      orderRemark: formValues.orderRemark,
      price: formValues.price,
      voiceUrl: formValues.voiceUrl,
      voiceLength: slen,
      serviceTime: formValues.serviceTime.toString(),
      orderArea: formValues.orderArea,
      goodLocation: formValues.goodLocation,
    }).then((res) => {
      this.setState({ loading: false });
      if (res.code == 200) {
        this.hideModal();
      } else {
        message.warning(res.message);
      }
    });
  };
  handleCurrencyChange = (v, name) => {
    const { formValues } = this.state;
    formValues[name] = v;
    this.setState({ formValues });
  };
  handleChangeByAvatar = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
    } else if (info.file.status === 'done') {
      const res = info.file.response;
      if (res.code === 200) {
        this.handleCurrencyChange(res.data.default, "skillPic");
      } else {
        message.error((res && res.message) || '上传失败，请稍候重试');
      }
      this.setState({ loading: false });
    } else if (info.file.status === 'error') {
      message.error('上传失败，请稍后重试~');
      this.setState({ loading: false });
    }
  };
  handleChangeBySound = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
    } else if (info.file.status === 'done') {
      const res = info.file.response;
      if (res.code === 200) {
        this.handleCurrencyChange(res.data.default, 'voiceUrl');
      } else {
        message.error((res && res.message) || '上传失败，请稍候重试');
      }
      this.setState({ loading: false });
    } else if (info.file.status === 'error') {
      message.error('上传失败，请稍后重试~');
      this.setState({ loading: false });
    }
  };
  render() {
    const { mode, base, skillName } = this.props;
    const {
      visible,
      skillType,
      gameDatas,
      skillItem,
      formValues,
      showSkillLy,
    } = this.state;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 3 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    };
    const soundUploadProps = {
      name: 'file',
      accept: '.mp3,.wav,.aac,.ogg',
      listType: 'picture-card',
      className: 'sound-uploader',
      action: base.rootConfig?.ctxPath + '/file/api/base/upload/audio',
      showUploadList: false,
      headers: {
        authorization: base.token,
        uid: base.uid,
      },
    };
    const avatarUploadProps = {
      name: 'file',
      accept: '.png,.jpg',
      listType: 'picture-card',
      className: 'avatar-uploader',
      action: base.rootConfig?.ctxPath + '/file/api/base/upload',
      showUploadList: false,
      headers: {
        authorization: base.token,
        uid: base.uid,
      },
    };
    const contentHtml = (
      <Scrollbar className="apply-scroll-bar" style={{ height: '600px' }}>
        <div
          className="iscroll-html"
          id="apply-scroll-bar"
          style={{ padding: '20px 50px' }}
        >
          <div className="applyClassly-box noSelect">
            {showSkillLy ? (
              <div className="game-boxs">
                {!!skillName && <h2 className="skill-name">{skillName}</h2>}
                {gameDatas.map((item, index) => (
                  <div key={index} className="game-box">
                    <h2>{item.typeDesc}</h2>
                    <div className="box-cons">
                      {item.skillItems &&
                        item.skillItems.map((citem, cindex) => (
                          <div
                            onClick={this.setSkillItems.bind(this, citem)}
                            className={
                              skillItem?.skillItemId == citem.skillItemId
                                ? 'con-item at'
                                : 'con-item'
                            }
                            key={cindex}
                          >
                            <img
                              alt=""
                              src={Util.transImgUrl(citem.skillItemIcon)}
                            />
                            <p>{citem.skillItemName}</p>
                          </div>
                        ))}
                    </div>
                  </div>
                ))}
              </div>
            ) : null}
            <div
              className={
                showSkillLy ? 'game-details' : 'game-details not-classly'
              }
            >
              {skillItem ? (
                <div>
                  <h1>{skillItem.skillItemName}</h1>
                  <Form
                    {...formItemLayout}
                    className="apply-form"
                    onFinish={this.handleSubmit}
                  >
                    {skillType == '2' ? (
                      <Form.Item label="认证要求">
                        <div className="ant-input-clone">
                          {skillItem.explain}
                        </div>
                      </Form.Item>
                    ) : null}
                    {formValues.showCategoryLevel ? (
                      <Form.Item label="技能等级">
                        <Select
                          value={formValues.level}
                          classNames={{
                            popup: { root: 'daidai-select-dropdown' },
                          }}
                          getPopupContainer={() => {
                            return document.getElementById('apply-scroll-bar');
                          }}
                          onChange={(v) => {
                            this.handleCurrencyChange(v, 'level');
                          }}
                          placeholder="-请选择-"
                          style={{ width: '350px' }}
                        >
                          {skillItem.level.map((lvitem, lvindex) => (
                            <Select.Option value={lvitem} key={lvindex}>
                              {lvitem}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    ) : null}
                    <Form.Item label="认证图片">
                      <p className="form-desc">
                        请参照示例上传截图：图片真实清晰，支持JPG/PNG格式，大小为2M以内
                      </p>
                      <div className="cz-map">
                        <img alt="" src={Util.transImgUrl(skillItem.pic)} />
                      </div>
                      <div className="cz-map">
                        <Upload
                          {...avatarUploadProps}
                          onChange={this.handleChangeByAvatar}
                        >
                          {formValues.skillPic ? (
                            <img
                              className="upload-image"
                              src={Util.transImgUrl(formValues.skillPic)}
                              alt="avatar"
                              style={{ width: '100%' }}
                            />
                          ) : (
                            <div className="uploadButton">
                              {this.state.loading ? (
                                <LoadingOutlined />
                              ) : (
                                <PlusOutlined />
                              )}
                            </div>
                          )}
                        </Upload>
                      </div>
                    </Form.Item>
                    <Form.Item label="服务单价">
                      <Select
                        value={formValues.price}
                        classNames={{
                          popup: { root: 'daidai-select-dropdown' },
                        }}
                        getPopupContainer={() => {
                          return document.getElementById('apply-scroll-bar');
                        }}
                        onChange={(v) => {
                          this.handleCurrencyChange(v, 'price');
                        }}
                        placeholder="-请选择-"
                        style={{ width: '350px' }}
                      >
                        {skillItem.prices.map((lvitem, lvindex) => (
                          <Select.Option value={lvitem} key={lvindex}>
                            {lvitem}
                            {lvindex === 0 ? (
                              <span
                                style={{ color: '#ea426c', padding: '0 5px' }}
                              >
                                （推荐价格）
                              </span>
                            ) : null}
                          </Select.Option>
                        ))}
                      </Select>
                      <span
                        className="que-action"
                        onClick={() => {
                          this.priceElement.showModal(skillItem.pricesAd);
                        }}
                      >
                        <QuestionCircleFilled />
                        <label>单价规则说明</label>
                      </span>
                    </Form.Item>
                    <Form.Item label="接单时间">
                      <Select
                        placeholder="开始时间"
                        value={formValues.timeStart}
                        classNames={{
                          popup: { root: 'daidai-select-dropdown' },
                        }}
                        getPopupContainer={() => {
                          return document.getElementById('apply-scroll-bar');
                        }}
                        onChange={(v) => {
                          this.handleCurrencyChange(v, 'timeStart');
                        }}
                        style={{ width: '160px' }}
                      >
                        {timsSelects.map((lvitem, lvindex) => (
                          <Select.Option value={lvitem} key={lvindex}>
                            {lvitem}
                          </Select.Option>
                        ))}
                      </Select>
                      <span className="timebfor">~</span>
                      <Select
                        placeholder="截止时间"
                        value={formValues.timeEnd}
                        classNames={{
                          popup: { root: 'daidai-select-dropdown' },
                        }}
                        getPopupContainer={() => {
                          return document.getElementById('apply-scroll-bar');
                        }}
                        onChange={(v) => {
                          this.handleCurrencyChange(v, 'timeEnd');
                        }}
                        style={{ width: '160px' }}
                      >
                        {timsSelects.map((lvitem, lvindex) => (
                          <Select.Option value={lvitem} key={lvindex}>
                            {lvitem}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    {skillType == '1' ? (
                      <Form.Item label="接单大区">
                        <Select
                          value={formValues.orderArea}
                          classNames={{
                            popup: { root: 'daidai-select-dropdown' },
                          }}
                          getPopupContainer={() => {
                            return document.getElementById('apply-scroll-bar');
                          }}
                          onChange={(v) => {
                            this.handleCurrencyChange(v, 'orderArea');
                          }}
                          placeholder="-请选择-"
                          style={{ width: '350px' }}
                        >
                          {!!skillItem?.orderArea?.length &&
                            skillItem.orderArea.map((lvitem, lvindex) => (
                              <Select.Option value={lvitem} key={lvindex}>
                                {lvitem}
                              </Select.Option>
                            ))}
                        </Select>
                      </Form.Item>
                    ) : null}
                    {skillType == '1' ? (
                      <Form.Item label="擅长位置">
                        <Select
                          value={formValues.goodLocation}
                          classNames={{
                            popup: { root: 'daidai-select-dropdown' },
                          }}
                          getPopupContainer={() => {
                            return document.getElementById('apply-scroll-bar');
                          }}
                          onChange={(v) => {
                            this.handleCurrencyChange(v, 'goodLocation');
                          }}
                          placeholder="-请选择-"
                          style={{ width: '350px' }}
                        >
                          {skillItem?.goodLocation?.map((lvitem, lvindex) => (
                            <Select.Option value={lvitem} key={lvindex}>
                              {lvitem}
                            </Select.Option>
                          ))}
                        </Select>
                      </Form.Item>
                    ) : null}
                    <Form.Item label="文字介绍">
                      <p className="form-desc">
                        请围绕该技能，介绍你的服务能力和个人特色吧~
                      </p>
                      <div className="control-row" style={{ width: '100%' }}>
                        <Input.TextArea
                          rows={4}
                          placeholder="请填写介绍内容"
                          value={formValues.orderRemark}
                          maxLength={100}
                          onChange={(v) => {
                            this.handleCurrencyChange(
                              v.target.value,
                              'orderRemark'
                            );
                          }}
                        />
                        <span className="control-count">
                          {formValues.orderRemark
                            ? formValues.orderRemark.length
                            : 0}
                          /12
                        </span>
                      </div>
                    </Form.Item>
                    <Form.Item label="语音介绍">
                      <p className="form-desc">
                        请录制一段自我介绍语音，展示自己的声音特色和个人魅力，时长5-15s
                      </p>
                      <div>
                        <Upload
                          {...soundUploadProps}
                          beforeUpload={this.checkSoundUploaded}
                          onChange={this.handleChangeBySound}
                        >
                          <div className="input-form-sound">
                            {formValues.voiceUrl ? (
                              <audio
                                ref={(el) => (this.soundElement = el)}
                                src={Util.transImgUrl(formValues.voiceUrl)}
                                onDurationChange={(e) => {
                                  this.handleCurrencyChange(
                                    this.soundElement.duration,
                                    'soundLen'
                                  );
                                }}
                                preload="auto"
                                controls
                              />
                            ) : (
                              <div className="uploadButton">
                                {this.state.loading ? (
                                  <LoadingOutlined />
                                ) : (
                                  <PlusOutlined />
                                )}
                                <p>支持上传Mp3、Wav格式文件</p>
                              </div>
                            )}
                          </div>
                        </Upload>
                        {formValues.voiceUrl ? (
                          <span
                            className="soundDelete"
                            onClick={() => {
                              this.handleCurrencyChange(null, 'voiceUrl');
                            }}
                          >
                            <DeleteOutlined title="删除" />
                          </span>
                        ) : null}
                      </div>
                    </Form.Item>
                    <Form.Item>
                      <div className="form-submits">
                        {mode == 'content' ? (
                          <Button
                            htmlType="submit"
                            loading={this.state.loading}
                            className="daidai-btn-primary"
                          >
                            下一步
                          </Button>
                        ) : (
                          <Button
                            htmlType="submit"
                            loading={this.state.loading}
                            className="daidai-btn-primary"
                          >
                            提交审核
                          </Button>
                        )}
                      </div>
                    </Form.Item>
                  </Form>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </Scrollbar>
    );
    return (
      <Fragment>
        {mode == 'content' ? (
          <Fragment>{contentHtml}</Fragment>
        ) : (
          <Modal
            open={visible}
            width={showSkillLy ? '980px' : '750px'}
            wrapClassName="daidai-modal-style has-top-border"
            centered={true}
            title={'技能申请'}
            footer={null}
            keyboard={false}
            maskClosable={false}
            destroyOnHidden={true}
            onCancel={this.hideModal}
          >
            <div>{contentHtml}</div>
          </Modal>
        )}
        {/* 单价规则说明 */}
        <PricesRemark wrappedComponentRef={(el) => (this.priceElement = el)} />
      </Fragment>
    );
  }
}

ApplyClassly.defaultProps = {
  mode: 'content', // content || modal
};

export default withRouter(ApplyClassly, { withRef: true });
